import { SortParams } from 'dashboard/lib/interfaces/SortParams';
import { List } from 'dashboard/models/list';
import { ListItem, ListItemStatus } from 'dashboard/models/list-item';
import { User } from 'dashboard/models/user';
import Action from 'lib/interfaces/Action';
import { PaginationParams } from 'lib/interfaces/api';
import { Iso8601DateString } from 'lib/types';

export interface ListFilterParams {
  status?: ListItemStatus[];
  createdAtStart?: Iso8601DateString;
  createdAtEnd?: Iso8601DateString;
  omni?: string;
}

export type ListActions =
  | Action<ListActionType.ClearList>
  | Action<ListActionType.SaveList, SaveListPayload>
  | Action<ListActionType.SaveListDetails, SaveListDetailsPayload>
  | Action<ListActionType.SaveListAndListDetails, SaveListAndListDetailsPayload>
  | Action<ListActionType.SaveListFilterParams, SaveListFilterParamsPayload>
  | Action<ListActionType.SetCurrentPage, SetCurrentPagePayload>
  | Action<ListActionType.SetPageSize, SetPageSizePayload>
  | Action<ListActionType.SetSortParams, SetSortParamsPayload>;

export enum ListActionType {
  ClearList = 'list/CLEAR_LIST',
  SaveList = 'list/SAVE_LIST',
  SaveListDetails = 'list/SAVE_LIST_DETAILS',
  SaveListAndListDetails = 'list/SAVE_LIST_AND_LIST_DETAILS',
  SaveListFilterParams = 'list/SAVE_LIST_FILTER_PARAMS',
  SetCurrentPage = 'list/SET_CURRENT_PAGE',
  SetPageSize = 'list/SET_PAGE_SIZE',
  SetSortParams = 'list/SET_SORT_PARAMS',
}

export function clearList(): Action<ListActionType.ClearList> {
  return { type: ListActionType.ClearList };
}

interface SaveListPayload {
  list: List;
}

export function saveList(list: List): Action<ListActionType.SaveList, SaveListPayload> {
  return {
    payload: {
      list,
    },
    type: ListActionType.SaveList,
  };
}

interface SaveListDetailsPayload {
  listItems: ListItem[];
  users: User[];
}

export function saveListDetails(
  listItems: ListItem[],
  users: User[],
): Action<ListActionType.SaveListDetails, SaveListDetailsPayload> {
  return {
    payload: {
      listItems,
      users,
    },
    type: ListActionType.SaveListDetails,
  };
}

interface SaveListAndListDetailsPayload {
  list: List;
  listItems: ListItem[];
  users: User[];
  paginationParams: PaginationParams;
}

export function saveListAndListDetails(
  list: List,
  listItems: ListItem[],
  users: User[],
  paginationParams: PaginationParams,
): Action<ListActionType.SaveListAndListDetails, SaveListAndListDetailsPayload> {
  return {
    payload: {
      list,
      listItems,
      users,
      paginationParams,
    },
    type: ListActionType.SaveListAndListDetails,
  };
}

interface SaveListFilterParamsPayload {
  filterParams: ListFilterParams;
}

export function saveListFilterParams(
  filterParams: ListFilterParams,
): Action<ListActionType.SaveListFilterParams, SaveListFilterParamsPayload> {
  return {
    payload: {
      filterParams,
    },
    type: ListActionType.SaveListFilterParams,
  };
}

interface SetCurrentPagePayload {
  currentPage: number;
}

export function setCurrentPage(
  currentPage: number,
): Action<ListActionType.SetCurrentPage, SetCurrentPagePayload> {
  return {
    payload: {
      currentPage,
    },
    type: ListActionType.SetCurrentPage,
  };
}

interface SetPageSizePayload {
  pageSize: number;
}

export function setPageSize(
  pageSize: number,
): Action<ListActionType.SetPageSize, SetPageSizePayload> {
  return {
    payload: {
      pageSize,
    },
    type: ListActionType.SetPageSize,
  };
}

interface SetSortParamsPayload {
  sortParams: SortParams;
}

export function setSortParams(
  sortParams: SortParams,
): Action<ListActionType.SetSortParams, SetSortParamsPayload> {
  return {
    payload: {
      sortParams,
    },
    type: ListActionType.SetSortParams,
  };
}
